var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0313437 5.58343C-0.38882 1.67704 3.49446 -1.19166 6.92526 0.492067L26.2269 9.96179C29.9244 11.7744 29.9244 17.2239 26.2269 19.0365L6.92526 28.5079C3.49446 30.1917 -0.387204 27.323 0.0313437 23.4166L0.80703 16.1728H13.9258C14.3544 16.1728 14.7655 15.9965 15.0685 15.6826C15.3716 15.3688 15.5418 14.9431 15.5418 14.4992C15.5418 14.0553 15.3716 13.6296 15.0685 13.3157C14.7655 13.0018 14.3544 12.8255 13.9258 12.8255H0.808646L0.03296 5.58343H0.0313437Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/send icon.fb346cc58727a3888a1dc8c6fe5f3996.svg";
export { ForwardRef as ReactComponent };